import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";
import ProductShow from "../components/ProductShow";
import Cart from "../components/Cart";
import MainTitle from "../components/MainTitle";
import LoadingSpinner from "../components/LoadingSpinner";
import WaMeLink from "../components/WaMeLink";
import ComingSoonProduct from "../components/ComingSoonProduct";

function ProductForm() {

    const navigate = useNavigate();

    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [discountAlertRendered, setDiscountAlertRendered] = useState(false);

    const { items, setItems, setDeliveryDate, setDeliveryDirection, setClientData, setSeller } = useContext(CheckoutContext);
    const containerRef = useRef(null);
    const [selectedProductIndex, setSelectedProductIndex] = useState(null);

const scrollPeekRight = () => {
        if (containerRef.current && products.length > 0) {
            const lastIndex = products.length - 1;
            if (containerRef.current.children[lastIndex]) {
                const item = containerRef.current.children[lastIndex];
                containerRef.current.scrollTo({
                    left: item.offsetLeft,
                    behavior: "smooth",
                });
                setTimeout(() => {
                    containerRef.current.scrollTo({ left: 0, behavior: "smooth" });
                }, 800);
            }
        }
    };

    useEffect(() => {
        async function getProducts() {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}product/active`);
                const data = response.data;

                await Promise.all(
                    data
                        .filter((p) => p.imageUrl)
                        .map(
                            (p) =>
                                new Promise((resolve) => {
                                    const img = new Image();
                                    img.onload = resolve;
                                    img.onerror = resolve;
                                    img.src = p.imageUrl;
                                })
                        )
                );

                setProducts(data);
                setIsLoaded(true);
            } catch (error) {
                console.log(error);
            }
        }
        getProducts();
    }, []);

    useEffect(() => {
        setItems([]);
        setDeliveryDate([]);
        setDeliveryDirection({});
        setClientData({});
        setSeller({});
    }, []);

    useEffect(() => {
        let total_quantity = 0;
        for (let i = 0; i < cart.length; i++) {
            total_quantity += cart[i].quantity;
        }
        setDisabled(total_quantity < 1);
    }, [cart]);

    useEffect(() => {
        if (containerRef.current && products.length > 0) {
            scrollPeekRight();
        }
    }, [products]);

    if (!isLoaded) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#f7f4ef]">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#f7f4ef]">

            {/* Header de marca */}
            <MainTitle />

            {/* Ancho acotado y centrado solo en desktop; en móvil queda full-bleed */}
            <div className="lg:max-w-6xl lg:mx-auto lg:px-6">

                {/* Strip informativo */}
                <div className="mx-4 mt-4 mb-3 px-3 py-2.5 bg-white rounded-xl border border-gray-100 shadow-sm lg:mt-6 lg:mb-5 lg:py-3">
                    <div className="flex flex-wrap justify-center gap-x-5 gap-y-1 lg:justify-around lg:gap-x-0">
                        <span className="flex items-center gap-1.5 text-[11px] text-gray-400 lg:text-[12px]">
                            <svg className="w-3 h-3 text-[#a02338] flex-shrink-0 lg:w-3.5 lg:h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
                            </svg>
                            Las Condes · Vitacura · Lo Barnechea
                        </span>
                        <span className="flex items-center gap-1.5 text-[11px] text-gray-400 lg:text-[12px]">
                            <svg className="w-3 h-3 text-[#a02338] flex-shrink-0 lg:w-3.5 lg:h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" />
                            </svg>
                            Pago seguro — Mercado Pago
                        </span>
                    </div>
                </div>

                {/* Desktop: productos a la izquierda, carrito fijo a la derecha. Móvil: apilado */}
                <div className="lg:grid lg:grid-cols-3 lg:gap-8 lg:items-start">

                    {/* Columna de productos */}
                    <div className="lg:col-span-2">

                        {/* Título sección productos */}
                        <div className="px-4 mb-1 flex items-center justify-between">
                            <h2 className="text-[15px] font-semibold text-[#2a1419] lg:text-[17px]">Elige tus productos</h2>
                        </div>

                        {/* Wrapper con padding para que el ring/sombra de cards activas no se recorte */}
                        <div className="overflow-hidden">
                            <div
                                className="flex gap-3 px-4 py-3 overflow-x-auto lg:grid lg:grid-cols-[repeat(auto-fit,minmax(200px,1fr))] lg:gap-5 lg:overflow-x-visible lg:py-4"
                                ref={containerRef}
                                style={{
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none",
                                    WebkitOverflowScrolling: "touch",
                                }}
                            >
                            {products.map((product, index) => (
                                <div
                                    key={product.id}
                                    className="flex-shrink-0 lg:w-full"
                                >
                                    <ProductShow
                                        product={product}
                                        cart={cart}
                                        setCart={setCart}
                                        setItems={setItems}
                                        items={items}
                                    />
                                </div>
                            ))}
                            {/* Producto por lanzar — solo vitrina, no se agrega al carro
                            <div className="flex-shrink-0 lg:w-full">
                                <ComingSoonProduct
                                    name="Cerezas"
                                    description="Caja 5 kgs"
                                    imageUrl="/productos/cerezas-proximamente.jpg"
                                />
                            </div>
                            */}
                            </div>
                        </div>
                    </div>

                    {/* Columna del carrito — acompaña el scroll en desktop */}
                    <div className="lg:col-span-1 lg:sticky lg:top-24">

                        {/* Separador — solo móvil, en desktop el carrito ya está separado por columna */}
                        <div className="flex items-center gap-3 px-4 my-4 lg:hidden">
                            <div className="flex-1 h-px bg-gray-200" />
                            <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">tu pedido</span>
                            <div className="flex-1 h-px bg-gray-200" />
                        </div>

                        {/* Carrito */}
                        <div className="pb-8 lg:pb-10">
                            <Cart
                                cart={cart}
                                disabled={disabled}
                                setDisabled={setDisabled}
                                discountAlertRendered={discountAlertRendered}
                                setDiscountAlertRendered={setDiscountAlertRendered}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <WaMeLink />
        </div>
    );
}

export default ProductForm;
